/** JSON `type` field sent to React Native WebView via `postMessage` when the player taps Continue on the result screen. */
export const RN_EXIT_MESSAGE_TYPE = "GAME_COMPLETED" as const;
/** JSON `type` field sent when the player leaves early (e.g. the debug exit
 * button) — distinct from RN_EXIT_MESSAGE_TYPE so the host can tell a manual
 * exit apart from an actual game completion. */
export const RN_DEBUG_EXIT_MESSAGE_TYPE = "GAME_EXITED" as const;
